// import { useEffect, useState } from "react";

// export default function Timer({ timer, onFinish, onSendTime, onGetTime  }) {
//   const [secondsElapsed, setSecondsElapsed] = useState(0);
//   const duration = 120;

//   // useEffect(() => {
//   //   if (timer) return;
//   //   const interval = setInterval(() => {
//   //     setSecondsElapsed((prev) => {
//   //       if (prev < duration && timer === false) {
//   //         return prev + 1;
//   //       } else {
//   //         onSendTime(formatTime(prev))
//   //         clearInterval(interval);
//   //         onFinish()
//   //         return prev;
//   //       }
//   //     });
//   //   }, 1000);

//   //   // Nettoyage au démontage du composant
//   //   return () => clearInterval(interval);
//   // }, [onFinish]);

//   useEffect(() => {
//     if (timer) return; // Si le timer est déjà terminé, ne rien faire

//     const interval = setInterval(() => {
//       setSecondsElapsed((prev) => {
//         if (prev + 1 < duration) {
//           return prev + 1;
//         } else {
//           clearInterval(interval); // ✅ Stoppe le setInterval
//           const finalTime = formatTime(prev + 1);
//           onSendTime(finalTime); // ✅ Envoie le temps final
//           onFinish(); // ✅ Appelle la fin une seule fois
//           return prev + 1;
//         }
//       });
//     }, 1000);

//     return () => clearInterval(interval); // 🔁 Nettoyage en cas de démontage
//   }, [timer]); // Ne pas inclure onFinish ici pour éviter de redémarrer le timer

//   // Appelle cette fonction pour renvoyer le temps actuel à tout moment
//   useEffect(() => {
//     if (onGetTime) {
//       onGetTime(() => formatTime(secondsElapsed));
//     }
//   }, [onGetTime, secondsElapsed]);

//   const secondsRemaining = duration - secondsElapsed;

//   const formatTime = (totalSeconds) => {
//     const minutes = Math.floor(totalSeconds / 60);
//     const seconds = totalSeconds % 60;
//     return `${minutes}:${seconds.toString().padStart(2, '0')}`;
//   };

//   return (
//     <div id="pTimer">
//         <span id="spanTimer">{formatTime(secondsElapsed)}</span>
//         / <span id="spanCountdown">{formatTime(secondsRemaining)}</span>
//     </div>
//   );
// }


// import { useEffect, useState } from "react";

// export default function Timer({
//   timer,          // booléen pour indiquer si le jeu est terminé (true = stop timer)
//   onFinish,       // callback appelée à la fin du timer (si limite atteinte)
//   onSendTime,     // callback pour envoyer le temps final
//   onGetTime,      // callback pour pouvoir récupérer le temps à tout moment
//   hasLimit = true, // 👈 nouvelle prop : true = 2 min max, false = pas de limite
//   limit = 120,     // 👈 optionnel : tu peux changer la limite (en secondes)
// }) {
//   const [secondsElapsed, setSecondsElapsed] = useState(0);

//   useEffect(() => {
//     if (timer) return; // Si le jeu est terminé, on arrête le timer

//     const interval = setInterval(() => {
//       setSecondsElapsed((prev) => {
//         const next = prev + 1;

//         if (hasLimit && next >= limit) {
//           clearInterval(interval);
//           const finalTime = formatTime(limit);
//           onSendTime(finalTime);
//           onFinish();
//           return limit;
//         }

//         return next;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [timer, hasLimit, limit, onFinish, onSendTime]);

//   // Permet de récupérer le temps actuel depuis le parent
//   useEffect(() => {
//     if (onGetTime) {
//       onGetTime(() => formatTime(secondsElapsed));
//     }
//   }, [onGetTime, secondsElapsed]);

//   const formatTime = (totalSeconds) => {
//     const minutes = Math.floor(totalSeconds / 60);
//     const seconds = totalSeconds % 60;
//     return `${minutes}:${seconds.toString().padStart(2, "0")}`;
//   };

//   const secondsRemaining = hasLimit ? limit - secondsElapsed : null;

//   return (
//     <div id="pTimer">
//       <span id="spanTimer">{formatTime(secondsElapsed)}</span>
//       {hasLimit && (
//         <>
//           {" / "}
//           <span id="spanCountdown">{formatTime(secondsRemaining)}</span>
//         </>
//       )}
//     </div>
//   );
// }

import { useEffect, useRef, useState } from "react";

export default function Timer({
  timer,          // booléen : true = stop timer
  onFinish,       // callback à la fin
  onSendTime,     // callback temps final
  onGetTime,      // callback temps actuel
  hasLimit = true,
  limit = 120,
}) {
  const [secondsElapsed, setSecondsElapsed] = useState(0);
  const startTimeRef = useRef(null);
  const intervalRef = useRef(null);

  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    // si le timer est terminé, stop
    if (timer) {
      clearInterval(intervalRef.current);
      return;
    }

    // on initialise le temps de départ une seule fois
    if (!startTimeRef.current) {
      startTimeRef.current = Date.now() - secondsElapsed * 1000;
    }

    intervalRef.current = setInterval(() => {
      const diff = Math.floor((Date.now() - startTimeRef.current) / 1000);

      if (hasLimit && diff >= limit) {
        clearInterval(intervalRef.current);
        onSendTime(formatTime(limit));
        onFinish();
        setSecondsElapsed(limit);
      } else {
        setSecondsElapsed(diff);
      }
    }, 250); // mise à jour fluide toutes les 250 ms

    return () => clearInterval(intervalRef.current);
  }, [timer, hasLimit, limit, onFinish, onSendTime]);

  // exposer le temps actuel
  useEffect(() => {
    if (onGetTime) {
      onGetTime(() => formatTime(secondsElapsed));
    }
  }, [onGetTime, secondsElapsed]);

  const secondsRemaining = hasLimit ? limit - secondsElapsed : null;

  return (
    <div id="pTimer">
      <span id="spanTimer">{formatTime(secondsElapsed)}</span>
      {hasLimit && (
        <>
          {" / "}
          <span id="spanCountdown">{formatTime(secondsRemaining)}</span>
        </>
      )}
    </div>
  );
}
